import { createContext, useReducer } from 'react';

export const Store = createContext();

function safeParse(jsonStr) {
  try {
    const parsed = JSON.parse(jsonStr);
    return parsed;
  } catch (err) {
    return null;
  }
}

const rawUserInfo = localStorage.getItem('userInfo');
const rawResentLink = localStorage.getItem('resentLink');
const rawResentBread = localStorage.getItem('resentBread');
const rawTotalSearch = localStorage.getItem('totalSearch');
const rawRememberMe = localStorage.getItem('rememberMe');

const initialState = {
  userInfo: rawUserInfo ? safeParse(rawUserInfo) : null,
  resentLink: rawResentLink ? safeParse(rawResentLink) : null,
  resentBread: rawResentBread ? safeParse(rawResentBread) : null,
  totalSearch: rawTotalSearch ? safeParse(rawTotalSearch) : 0,
  rememberMe: rawRememberMe ? safeParse(rawRememberMe) : null,
};

function reducer(state, action) {
  switch (action.type) {
    case 'USER_SIGNIN':
      localStorage.setItem('userInfo', JSON.stringify(action.payload));
      return { ...state, userInfo: action.payload };
    case 'USER_SIGNOUT':
      localStorage.removeItem('userInfo');
      return { ...state, userInfo: null };

    case 'PREV-LINK':
      localStorage.setItem('resentLink', JSON.stringify(action.payload));
      return { ...state, resentLink: action.payload };

    case 'SET_BREADCRUMB':
      localStorage.setItem('resentBread', JSON.stringify(action.payload));
      return { ...state, resentBread: action.payload };

    case 'SET_TOTALSEARCH':
      localStorage.setItem('totalSearch', JSON.stringify(action.payload));
      return { ...state, totalSearch: action.payload };

    case 'SET_REMEMBERME':
      localStorage.setItem('rememberMe', JSON.stringify(action.payload));
      return { ...state, rememberMe: action.payload };
    default:
      return state;
  }
}

export function StoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <Store.Provider value={value}>{props.children}</Store.Provider>;
}
